import { render } from "./LuckyRewardsThisWeek.vue?vue&type=template&id=add50576"
import script from "./LuckyRewardsThisWeek.vue?vue&type=script&lang=js"
export * from "./LuckyRewardsThisWeek.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__